/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_ContentInputs */

const en_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTENT`)
};

const ar_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#محتوى`)
};

const bn_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTENT`)
};

const de_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTENT`)
};

const es_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTENT`)
};

const fr_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTENT`)
};

const pt_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTENT`)
};

const zh_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTENT`)
};

const tr_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTENT`)
};

const ru_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTENT`)
};

const pl_svtag_content = /** @type {(inputs: Svtag_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTENT`)
};

/**
* | output |
* | --- |
* | "#CONTENT" |
*
* @param {Svtag_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_content = /** @type {((inputs?: Svtag_ContentInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_ContentInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_content(inputs)
	if (locale === "bn") return bn_svtag_content(inputs)
	if (locale === "de") return de_svtag_content(inputs)
	if (locale === "es") return es_svtag_content(inputs)
	if (locale === "fr") return fr_svtag_content(inputs)
	if (locale === "pt") return pt_svtag_content(inputs)
	if (locale === "zh") return zh_svtag_content(inputs)
	if (locale === "tr") return tr_svtag_content(inputs)
	if (locale === "ru") return ru_svtag_content(inputs)
	if (locale === "pl") return pl_svtag_content(inputs)
	return en_svtag_content(inputs)
});